module.exports = __webpack_public_path__ + "img/greatplace.f19b0550.png";